module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('text-input', {
    attrs: {
      "type": "area",
      "rows": _vm.rows,
      "disabled": _vm.disabled
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-697cf88c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/inputs/TextArea.vue
// module id = 1617
// module chunks = 0